const CUSTOM_TOPICS = ["Skip/No Class", "Exam", "LAST CLASS"];
export default CUSTOM_TOPICS;
